import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/payMerchant/getList',
        method: 'post',
        data: data
    })
}
export function getType1TargetList(data) {
    return request({
        url: '/backend/payMerchant/getType1TargetList',
        method: 'post',
        data: data
    })
}
export function getType3TargetList(data) {
    return request({
        url: '/backend/payMerchant/getType3TargetList',
        method: 'post',
        data: data
    })
}
export function getTypePaymentMerchant(data) {
    return request({
        url: '/backend/payMerchant/getTypePaymentMerchant',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/payMerchant/delete',
        method: 'post',
        data: data
    })
}
export function addTypeTarget(data) {
    return request({
        url: '/backend/payMerchant/addTypeTarget',
        method: 'post',
        data: data
    })
}